const YourRights = () => {
  return (
    <div className="mb-8">
      <h2 id="your-rights" className="text-2xl font-semibold mb-4">Your Rights</h2>
      <p className="mb-6">You have the following data protection rights:</p>
      <ul className="list-disc pl-6 mb-8">
        <li className="mb-2">The right to access, update or delete the information we have on you</li>
        <li className="mb-2">The right of rectification - the right to have your information corrected if it is inaccurate or incomplete</li>
        <li className="mb-2">The right to object - the right to object to our processing of your personal data</li>
        <li className="mb-2">The right of restriction - the right to request that we restrict the processing of your personal information</li>
        <li className="mb-2">The right to data portability - the right to receive a copy of your personal information in a structured, machine-readable format</li>
        <li className="mb-2">The right to withdraw consent - the right to withdraw your consent at any time where we relied on your consent to process your personal information</li>
      </ul>
    </div>
  );
};

export default YourRights;